export const appConstants = {
    canonicalUrl: 'https://easysavingsspecials.com',
    cardIconsMapping: {
        MAST: 'master.png',
        Unknown: 'credit.png',
    },
    basicInfo: {
      email: { display: 'support@easysavingsspecials.com', val: 'support@easysavingsspecials.com' },
        phone: { display: '', val: '' }
    },
  baseTitle: 'Mastercard Easy Savings Specials',
    categories: {
      'productivity': { 
          name: $localize`Improve your <b class = "f500">productivity</b>`,
          img: 'https://images.poshvine.com/icon/m-productivity.svg',
          subtitle: `Improve your productivity`
        },
      'cloud-infrastructure': { 
        name: $localize`Take your business to the <b class = "f500">cloud</b>`,
        img: 'https://images.poshvine.com/icon/m-cloud.svg',
        subtitle: `Take your business to the cloud`
      },
      'workspaces-office-essentials': { 
        name: $localize`Set up your <b class = "f500">dream office</b>`,
        img: 'https://images.poshvine.com/icon/m-workspace.svg',
        subtitle: `Set up your dream office`
      },
      'customer-support': { 
        name: $localize`Improve your <b class = "f500">customer centricity</b>`,
        img: 'https://images.poshvine.com/icon/Improve-your-customer-centricity.svg',
        subtitle: `Improve your customer centricity`
      },
      'business-solutions': { 
        name: $localize`<b class = "f500">Business solutions</b>`,
        img: 'https://images.poshvine.com/icon/m-business.svg',
        subtitle: `Business solutions`
      },
      'learning': { 
        name: $localize`Hire better, <b class = "f500">learn more</b>`,
        img: 'https://images.poshvine.com/icon/m-hr.svg',
        subtitle: `Hire better, learn more`
      },
      'business-travel-entertainment': { 
        name: $localize`Save on <b class = "f500">travel & entertainment</b>`,
        img: 'https://images.poshvine.com/icon/m-business.svg',
        subtitle: `Save on travel & entertainment`
      },
      'logistics': { 
        name: $localize`Power your <b class = "f500">logistics</b>`,
        img: 'https://images.poshvine.com/icon/m-delhivery.svg',
        subtitle: `Power your logistics`
      },
      'marketing': { 
        name: $localize`Unleash <b class = "f500">business growth</b>`,
        img: 'https://images.poshvine.com/icon/m-sales-marketing.svg',
        subtitle: `Unleash business growth`
      },
      'finance': { 
        name: $localize`Simplify your <b class = "f500">finances</b>`,
        img: 'https://images.poshvine.com/icon/m-finance.svg',
        subtitle: `Simplify your finances`
      },
      'hr-learning': { 
        name: $localize`<b class = "f500">Hire</b> better, <b class = "f500">learn</b> more`,
        img: 'https://images.poshvine.com/icon/m-hr.svg',
        subtitle: `Hire better, learn more`
      },
      'sales': { 
        name: $localize`Unleash <b class = "f500">business growth</b>`,
        img: 'https://images.poshvine.com/icon/m-sales-marketing.svg',
        subtitle: `Unleash business growth`
      },
      'Office-Supplies-Publications': { 
        name: $localize`Power up your <b class = "f500">office supplies</b>`,
        img: 'https://images.poshvine.com/icon/m-office-supplies.svg',
        subtitle: `Power up your office supplies`
      },
      'security-compliance': { 
        name: $localize`Stay <b class="f500">secure</b>, stay <b class="f500">compliant</b>`,
        img: 'https://images.poshvine.com/icon/mc_icon_mobile_lock-locked_orng.svg',
        subtitle: `Stay secure, stay compliant`
      },
      'local-offers': { 
        name: $localize`Save on <b class = "f500">local business essentials</b>`,
        img: 'https://images.poshvine.com/icon/m-local-offers-min.svg',
        subtitle: `Save on local business essentials`
      },
      'online-readiness': { 
        name: $localize`Scale your business to the <b class = "f500">next level</b>`,
        img: 'https://images.poshvine.com/icon/m-cloud.svg',
        subtitle: `Scale your business to the next level`
      },
      'every-day-value': { 
        name: $localize`Always-On <b class = "f500">daily benefits</b>`,
        img: 'https://images.poshvine.com/icon/everyDayValue.svg',
        subtitle: `Always-On daily benefits`
      },
      'driving-savings-and-purpose': { 
        name: `<b class="f500">Driving Savings and Purpose</b>`,
        img: 'https://images.poshvine.com/icon/environmentalSustainability.svg',
        subtitle: `Driving Savings and Purpose`
      },
      'ai-tools': {
        name: `Smarter tools, <b class = "f500">better business</b>`,
        img: './assets/img/icons/ai-tools.svg',
        subtitle: `Smarter tools, better business`
      },
    }
}